var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5V12.51",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 5.42804C18.321 4.67789 16.8566 4.70345 15 5.4991C13.1435 6.29475 11.047 7.79531 9.17161 9.67068C7.29625 11.546 5.79569 13.6426 5.00004 15.4991C4.20439 17.3556 4.17882 18.82 4.92897 19.5702C5.67911 20.3203 7.14352 20.2948 9.00004 19.4991C10.8566 18.7035 12.9531 17.2029 14.8285 15.3275C15.757 14.3989 16.6034 13.4063 17.3191 12.4062C18.0349 11.4062 18.6061 10.4184 19 9.4991C19.394 8.57985 19.603 7.7472 19.6152 7.04868C19.6274 6.35017 19.4425 5.79947 19.0711 5.42804",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92901 5.42939C4.17887 6.17953 4.20443 7.64394 5.00008 9.50045C5.79573 11.357 7.29629 13.4535 9.17165 15.3289C11.047 17.2042 13.1436 18.7048 15.0001 19.5005C16.8566 20.2961 18.321 20.3217 19.0711 19.5715C19.8213 18.8214 19.7957 17.357 19.0001 15.5005C18.2044 13.6439 16.7039 11.5474 14.8285 9.67203C13.8999 8.74344 12.9073 7.89711 11.9072 7.18135C10.9072 6.46559 9.91933 5.89442 9.00008 5.50045C8.08083 5.10649 7.24817 4.89744 6.54966 4.88525C5.85114 4.87305 5.30045 5.05795 4.92901 5.42939",
    stroke: "#CBD5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtom);
export default __webpack_public_path__ + "static/media/atom.b9e9845df0b2a463b981917bf4d9c278.svg";
export { ForwardRef as ReactComponent };